import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface BlogMarkdownProps {
  content: string;
}

export default function BlogMarkdown({ content }: BlogMarkdownProps) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      skipHtml
      components={{
        p: ({ node: _node, ...props }) => <p className="mb-6" {...props} />,
        h1: ({ node: _node, ...props }) => (
          <h1 className="mt-10 mb-4 text-3xl font-semibold" {...props} />
        ),
        h2: ({ node: _node, ...props }) => <h2 className="font-semibold" {...props} />,
        h3: ({ node: _node, ...props }) => <h3 className="font-semibold" {...props} />,
        h4: ({ node: _node, ...props }) => (
          <h4 className="mt-7 mb-3 text-xl font-semibold" {...props} />
        ),
        ul: ({ node: _node, ...props }) => (
          <ul className="mb-6 list-disc space-y-2 pl-6" {...props} />
        ),
        ol: ({ node: _node, ...props }) => (
          <ol className="mb-6 list-decimal space-y-2 pl-6" {...props} />
        ),
        strong: ({ node: _node, ...props }) => (
          <strong className="font-semibold text-gray-900" {...props} />
        ),
        hr: ({ node: _node, ...props }) => <hr className="my-8 border-blue-100" {...props} />,
        pre: ({ node: _node, ...props }) => (
          <pre className="mb-6 overflow-x-auto rounded-xl bg-slate-50 p-5 text-sm" {...props} />
        ),
        table: ({ node: _node, ...props }) => (
          <div className="my-8 overflow-x-auto">
            <table
              className="!table w-full min-w-[28rem] border-collapse text-left text-sm"
              {...props}
            />
          </div>
        ),
        thead: ({ node: _node, ...props }) => <thead className="bg-blue-50" {...props} />,
        th: ({ node: _node, ...props }) => (
          <th
            scope="col"
            className="border border-blue-100 px-4 py-3 font-semibold text-gray-900"
            {...props}
          />
        ),
        td: ({ node: _node, ...props }) => (
          <td className="border border-blue-100 px-4 py-3 align-top" {...props} />
        ),
        img: ({ node: _node, src, ...props }) =>
          src ? <img loading="lazy" src={src} {...props} /> : null,
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
